import { ReactNode } from 'react';
import { Container, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import HeroContainer from '~/components/HeroContainer';
import { useTheme } from '@mui/material/styles';

interface StandardPageProps {
  children: ReactNode;
  bannerContent?: ReactNode;
}

function StandardPage({ children, bannerContent }: StandardPageProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box mb={20}>
      <Box mb={5}>
        <HeroContainer
          backgroundColor={theme.palette.secondary.main}
          height={'auto'}
        >
          <Box pt={isMobile ? 2 : 5} pb={isMobile ? 2 : 5}>
            <Container>
              {bannerContent}
            </Container>
          </Box>
        </HeroContainer>
      </Box>
      <Box>
        <Container>
          {children}
        </Container>
      </Box>
    </Box>
  );
}

export default StandardPage;
